import { render, staticRenderFns } from "./MoviePart.vue?vue&type=template&id=61a5c568&scoped=true"
import script from "./MoviePart.vue?vue&type=script&lang=js"
export * from "./MoviePart.vue?vue&type=script&lang=js"
import style0 from "./MoviePart.vue?vue&type=style&index=0&id=61a5c568&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a5c568",
  null
  
)

export default component.exports